<template>
    <div class="mb20 relative">
        <div style="height: 170px" id="amap"></div>
        <div class="absolute time fs12 flex aic jcc" v-if="showTime&&traceList.length">
            {{distance}}({{time}})
        </div>
    </div>
</template>

<script>
    import {MAIN_COLOR} from "../../../common/lib/config";
    import {MapMixin} from "../mixins";

    export default {
        name: "car-map",
        mixins: [MapMixin],
        data() {
            return {
            };
        },
        computed: {},
        mounted() {
            // eslint-disable-next-line no-undef
            this.map = new AMap.Map("amap", {
                zoom: 7,
                resizeEnable: true,
                center: [120.209947, 30.245853]
            });
            this.map.on("click", this.showMapDialog);
            this.getDriving();
            //this.getMaker();
        },
        watch: {
            info() {
                this.getDriving();
            }
        },
        methods: {
            showMapDialog() {
                this.$emit('big', 1);
            },


            getMaker() {
                this.maker = new AMap.Marker({
                    map: this.map,
                    position: new AMap.LngLat(120, 31.026666),
                    icon: new AMap.Icon({
                        size: new AMap.Size(26, 13),
                        image: "https://webapi.amap.com/images/car.png",
                        imageSize: new AMap.Size(26, 13)
                    }),
                    offset: new AMap.Pixel(-13, -6),
                    autoRotation: true,
                    angle: 90
                });
            },

            loadUI() {
                //at.alicdn.com/t/font_959824_cdx5a7zs7ho.js
                AMapUI.loadUI(["overlay/SvgMarker"], SvgMarker => {
                    var marker1 = new SvgMarker(
                        new SvgMarker.Shape.IconFont({
                            // 参见 symbol引用, http://www.iconfont.cn/plus/help/detail?helptype=code
                            symbolJs: "//at.alicdn.com/t/font_959824_cdx5a7zs7ho.js",
                            icon: "icon-cheliang",
                            size: 24,
                            offset: [0, 0],
                            fillColor: MAIN_COLOR
                        }),
                        {
                            map: this.map,
                            position: new AMap.LngLat(120, 31.026666),
                            showPositionPoint: true
                        }
                    );
                });
            }
        }
    };
</script>

<style scoped lang="scss">
    .time {
        color: white;
        left: 0;
        top: 0;
        padding: 10px 20px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
    }
</style>
